import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { COR_PRIMARIA_PDF } from '@/nucleo/pdf/cores';

import type { EmpenhoLinha, LoteSofLinha } from '../types';

const ROTULO_STATUS_EMPENHO: Record<EmpenhoLinha['status'], string> = {
  PRE_EMPENHO: 'Pré-empenho',
  EMPENHADO: 'Empenhado',
  ANULADO: 'Anulado',
};

const formatarMoeda = (valor: string) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(valor));

export function exportarLoteSofPdf(lote: LoteSofLinha, empenhos: EmpenhoLinha[]): void {
  const documento = new jsPDF({ orientation: 'landscape' });
  documento.setFontSize(14);
  documento.text(`Lote SOF ${lote.numeroLote ?? lote.id}`, 14, 16);
  documento.setFontSize(10);
  documento.text(
    `Competência: ${new Date(lote.mesReferencia).toLocaleDateString('pt-BR', { month: '2-digit', year: 'numeric' })}` +
      (lote.dreNome ? ` · DRE: ${lote.dreNome}` : ' · Todas as DREs'),
    14,
    24,
  );
  documento.text(`Emitido em: ${new Date().toLocaleString('pt-BR')}`, 14, 30);

  autoTable(documento, {
    startY: 36,
    head: [['Nº NE', 'Dotação', 'Credenciado', 'Valor', 'Status']],
    body: empenhos.map((e) => [
      e.numeroNe,
      e.dotacaoOrcamentaria,
      e.credenciadoNome,
      formatarMoeda(e.valor),
      ROTULO_STATUS_EMPENHO[e.status],
    ]),
    styles: { fontSize: 8 },
    headStyles: { fillColor: COR_PRIMARIA_PDF },
    foot: [['', '', 'Total do lote', formatarMoeda(lote.valorTotal), '']],
  });

  documento.save(`lote-sof-${lote.numeroLote ?? lote.id}.pdf`);
}
